export default import.meta.ROLLDOWN_FILE_URL_8Hya7qL9A0HZa7wYzK3OEg